import { QData } from "../../../types/basic-type-list";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import {
  IAdminUser,
  ILoginResponse,
  IUser,
  IUserInfo,
  IUserLoginPayload,
  IUserLoginResponse,
  IUserUpdatePasswordPayload,
  IUserUpdateProfilePayload,
} from "../../../types/api/user";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { AxiosResponse } from "axios";
import { IRegisteredUserListResponse } from "../../../types/api/users-manage";
import { IDeleteDataResponseAndPayload } from "../../../types/api/contact";

export async function userUpdatePassword(
  data: IUserUpdatePasswordPayload
): Promise<AxiosResponse<TResponse<IUser>>> {
  return axios.post<TResponse<IUser>>(
    API_ENDPOINTS.ADMIN_UPDATE_PASSWORD,
    data
  );
}

export async function validateToken(): Promise<
  AxiosResponse<TResponse<IUserInfo>>
> {
  return axios.get<TResponse<IUserInfo>>(API_ENDPOINTS.VALIDATE_TOKEN);
}

export async function userUpdatedProfile(
  data: IUserUpdateProfilePayload
): Promise<AxiosResponse<TResponse<IUser>>> {
  return axios.post<TResponse<IUser>>(API_ENDPOINTS.ADMIN_SAVE, data);
}

export async function getUserInfo(): Promise<AxiosResponse<TResponse<IUserInfo>>> {
  return axios.get<TResponse<IUserInfo>>(API_ENDPOINTS.ADMIN_DETAIL);
}

export async function userLogin(
  data: IUserLoginPayload
): Promise<AxiosResponse<TResponse<ILoginResponse>>> {
  return axios.post<TResponse<ILoginResponse>>(
    API_ENDPOINTS.ADMIN_LOGIN,
    data
  );
}


// app user list

export async function RegisteredUserList(qData: QData): Promise<AxiosResponse<TResponseWithQData<IRegisteredUserListResponse[]>>> {
    return axios.get(API_ENDPOINTS.REGISTERED_USER_LIST, {
        params: qData
    })
}

export async function createUser(data: IRegisteredUserListResponse): Promise<AxiosResponse<TResponse<IRegisteredUserListResponse>>> {
    return axios.post<TResponse<IRegisteredUserListResponse>>(API_ENDPOINTS.CREATE_USER, data)
}

export async function userDetails(id:string): Promise<AxiosResponse<TResponse<IRegisteredUserListResponse>>> {
    return axios.get(`${API_ENDPOINTS.REGISTERED_USER_DETAILS}/${id}`)
}


export async function deleteUsers(data: IDeleteDataResponseAndPayload): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
    return axios.post<TResponse<IDeleteDataResponseAndPayload>>(API_ENDPOINTS.REGISTERED_USER_DELETE, data)
}
